import React from 'react';
import { Pressable, StyleSheet, Platform } from 'react-native';
import { Link } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    flexShrink: 0,
    paddingVertical: 2,
  },
});

/**
 * Compact "View all X →" link rendered on the right of an {@link ExploreSection}
 * title (e.g. "Models" → /models, "Tools" → /tools). Shown to every visitor.
 *
 * @param {string} href - route to navigate to
 * @param {string} label - link text (e.g. "View all models")
 */
function SectionViewAllLink({ href, label }) {
  const { colors } = useTheme();

  return (
    <Link href={href} asChild withAnchor={true}>
      <Pressable
        accessibilityRole="link"
        accessibilityLabel={label}
        hitSlop={6}
        style={({ hovered, pressed }) => [
          styles.row,
          Platform.OS === 'web' && { cursor: 'pointer' },
          (pressed || hovered) && { opacity: 0.7 },
        ]}
      >
        <Text size="s" weight="medium" style={{ color: colors.accent_color_primary }}>
          {label}
        </Text>
        <Icon name="arrow-right" size={11} color={colors.accent_color_primary} />
      </Pressable>
    </Link>
  );
}

export default React.memo(SectionViewAllLink);
